<template>
  <div class="pay-succ">
    <div>
      <iconpark-icon name="pay-succ" class="text-[56px]"></iconpark-icon>
    </div>
    <div class="pay-succ__h1">{{ title }}</div>
    <div class="pay-succ__h2">{{ desc }}</div>
    <div v-if="showPullNewInfo" class="text-center text-font-70 mt-[15px]">
      <div>
        <div v-if="inviteProps?.award.accept_total_credit_coins">
          {{
            $t(
              'nin-yi-wan-cheng-hao-you-zhu-li-jiang-li-nin-invitepropsawardaccepttotalcreditcoins-yan-bi',
              [inviteProps.award.accept_total_credit_coins]
            )
          }}
        </div>
        <div v-if="inviteProps?.award.invitation_total_credit_coins">
          <span v-if="!inviteProps.award.accept_total_credit_coins">
            {{ $t('nin-yi-wan-cheng-hao-you-zhu-li') }}
          </span>
          {{
            $t(
              'nin-de-hao-you-huo-de-invitepropsawardinvitationtotalcreditcoins-yan-bi',
              [inviteProps.award.invitation_total_credit_coins]
            )
          }}
        </div>
        <div>
          {{ $t('kuai-lai-huo-qu-nin-de') }}
          <a @click="inviteProps?.cb">
            {{ $t('zhuan-shu-yao-qing-lian-jie') }}
          </a>
          ，{{ $t('yao-qing-hao-you-gong-xiang-quan-yi-ba') }}
        </div>
      </div>
    </div>
    <!-- <slot name="content"></slot> -->
    <div v-if="payType" class="pay-succ__h3">
      {{ seconds }}s 后关闭页面，{{ tip }}
    </div>
  </div>
</template>

<script setup lang="ts" name="PaySucc">
import type { Loose } from '~/api/interface'
import { LOCAL_KEY } from '~/constants/config'

const { inviteProps } = defineProps<{
  title?: string
  desc?: string
  tip?: string
  inviteProps?: {
    isInviteUser: boolean // 是否是被邀请用户
    award: Loose // 奖励内容
    cb(): void // 点击专属链接的回调
  }
}>()

// 显示邀请信息
const showPullNewInfo = computed(
  () =>
    inviteProps?.isInviteUser &&
    (inviteProps?.award.accept_total_credit_coins ||
      inviteProps?.award.invitation_total_credit_coins)
)

const route = useRoute()

const payType = computed(() => route.query?.pay_type)

const emits = defineEmits(['onSuccess'])

const timer: any = ref()
const seconds = ref(5)
onMounted(() => {
  if (payType.value) {
    timer.value = setInterval(() => {
      if (seconds.value <= 0) {
        emits('onSuccess')
        clearInterval(timer.value)
        localSetItem(LOCAL_KEY.UPDATE_USERINFO, Date.now())
        window.close()

        return
      }
      seconds.value--
    }, 1000)
  }
})
</script>

<style lang="scss">
.pay-succ {
  padding: 30px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  &__h1 {
    padding-top: 20px;
    padding-bottom: 16px;
    font-size: 24px;
    font-weight: bold;
    line-height: 34px;
  }
  &__h2 {
    font-size: 16px;
    line-height: 24px;
  }
  // &__h3 {
  //   padding-top: 36px;
  //   font-size: 12px;
  //   line-height: 18px;
  //   opacity: .6;
  // }
}
</style>
